export const actionTypes = {
    TILE_LAYER_SET_OPACITY: 'TILE_LAYER/SET_OPACITY',

    PIN_TILE_LAYER: 'TILE_LAYER/PIN',
    UNPIN_TILE_LAYER: 'TILE_LAYER/UNPIN',
};
